module.exports = __webpack_public_path__ + "static/media/child1.4b0a2c74.png";